import * as types from '../mutation-types'
import { api } from './../../modules/api'
import { getEventLink } from '@/store/modules/general-settings'

const state = () => ({
  letter: {
    data: null,
    showMessage: false
  }
})

const getters = { getLetter: state => state.letter }

const actions = {
  async sendSingleLetter ({ commit }, { payload, route = 'blitz' }) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      const response = await this.$axios.post(
        api.invitationSingle.getDinamicLetterLink(route),
        payload
      )

      const modalRouteName = {
        blitz: 'blitz-registration',
        listing: 'listing'
      }
      const {
        status,
        statusText: text,
        data: { token }
      } = response

      const data = {
        status,
        text,
        invitationLink: `${getEventLink()}/${modalRouteName[route]}?token=${window.encodeURIComponent(token)}`
      }
      commit(types.SEND_SINGLE_LETTER, data)
      commit(types.CREATE_SUCCESS_MESSAGE, 'E-mail was sent successfully!')
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE)
    }
    commit(types.SET_SPINNER_STATUS, false)
  },
  closeLetterModal ({ commit }) {
    commit(types.SET_LETTER_MODAL_VISIBILITY, false)
  }
}

const mutations = {
  [types.SEND_SINGLE_LETTER] (state, data) {
    state.letter.data = data
    state.letter.showMessage = true
  },
  [types.SET_LETTER_MODAL_VISIBILITY] (state, status) {
    state.letter.showMessage = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invitationSingle.js